// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2R4AS","rootMobile":"styles_rootMobile__1E2h3"};